import { render, staticRenderFns } from "./GGBreadcrumbs.vue?vue&type=template&id=44b93c94&"
import script from "./GGBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./GGBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./GGBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b93c94')) {
      api.createRecord('44b93c94', component.options)
    } else {
      api.reload('44b93c94', component.options)
    }
    module.hot.accept("./GGBreadcrumbs.vue?vue&type=template&id=44b93c94&", function () {
      api.rerender('44b93c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGBreadcrumbs.vue"
export default component.exports